import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import Box from 'ui-box';
import HeaderBack from '../../../../components/mobile/speak-doctor/HeaderBack';
import SelectableItemBox from '../../../../components/mobile/SelectableItemBox';

function MobilePregnantScreen() {
  const { t } = useTranslation(['common', 'speak-doctor']);
  const [selectedNextPath, setSelectedNextPath] = useState('/speak-doctor/pregnancy')
  const history = useHistory();

  const options = [
    {
      'label': t('speak-doctor:pregnant.menu.planningPregnant'),
      'value': '/speak-doctor/pregnancy/planning-get-pregnant/first-day-last-period'
    },
    {
      'label': t('speak-doctor:pregnant.menu.currentPregnant'),
      'value': '/speak-doctor/pregnancy/current-pregnant/first-day-last-period'
    },
    {
      'label': t('speak-doctor:pregnant.menu.newParent'),
      'value': '/speak-doctor/pregnancy/new-parent/when-baby-born'
    },
  ]

  const onChange = (value) => {
    setSelectedNextPath(value)
  }

  const onNext = () => {
    history.push(selectedNextPath);
  }

  return (
    <>
      <HeaderBack
        previousPage='/speak-doctor'
        text={t('speak-doctor:pregnant.previousPage')}
        title={t('speak-doctor:pregnant.title')}
        subtitle={t('speak-doctor:pregnant.subtitle')}
      />
      {options.map(({ value, label }) => {
        return (
          <Box
            key={value}
            paddingBottom={24}
            paddingLeft={5}
            paddingRight={5}
            maxWidth="480px"
            marginY={0}
            marginX="auto"
          >
            <SelectableItemBox
              isSelected={value === selectedNextPath}
              isTextCentred
              onClick={() => onChange(value)}
            >
              {t(label)}
            </SelectableItemBox>
          </Box>
        );
      })}
      <Box
        position="absolute"
        bottom="50px"
        marginLeft="auto"
        marginRight="auto"
        left="0"
        right="0"
        width="100%"
        maxWidth="480px"
        paddingX={20}
      >
        <Button
          htmlType="button"
          type="primary"
          size="large"
          onClick={onNext}
          block
        >
          {t(`common:button.next`)}
        </Button>
      </Box>
    </>
  );
}

const styles = {
  title: {
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "26px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#404047"
  },
  divider: {
    fontSize: 15,
    fontWeight: 400,
    color: '#404047',
    margin: 0
  },
  selectOption: {
    fontWeight: "300",
    fontSize: "15px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#15A9E1"
  }
}

export default MobilePregnantScreen;
